// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Card":"Card","AspectRatioImage__figure":"AspectRatioImage__figure","Card__bottom":"Card__bottom","Card__caption":"Card__caption","Card__title":"Card__title"};